import PropTypes from "prop-types";

// Renders an email value as plain text. The verification status icon is NOT
// rendered here: FormDisplayField renders a single EmailVerificationBadge
// alongside this component (see FormDisplayField). Rendering a status icon here
// too produced two near-identical badges per email field. EmailVerificationBadge
// is the canonical badge (richer status set + domain tooltip) and is also used
// in the edit path (FormEmailField) and DataObjectFieldsPreview.
function FormEmailDisplayField({ value }) {
    return <span>{value}</span>;
}

FormEmailDisplayField.propTypes = {
    value: PropTypes.string,
};

export default FormEmailDisplayField;
